<tokens-browser-name [name]="name" [registeredNames]="registeredNames" (newName)="onNewName($event)" (back)="onBack($event)">
</tokens-browser-name>
